import React, { useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Polyline, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './MapView.css';

// カスタムマーカーアイコンの作成
const createCustomMarker = (isRiding) => {
    const color = isRiding ? '#ff0000' : '#0066cc';
    return L.divIcon({
        html: `
            <div style="
                width: 16px;
                height: 16px;
                background-color: ${color};
                border: 2px solid #ffffff;
                border-radius: 50%;
                box-shadow: 0 2px 4px rgba(0,0,0,0.3);
            "></div>
        `,
        className: 'custom-marker',
        iconSize: [16, 16],
        iconAnchor: [8, 8]
    });
};

// マップセンターとズームを動的に更新するコンポーネント
const MapController = ({ center, route }) => {
    const map = useMap();

    useEffect(() => {
        if (center) {
            map.setView([center.lat, center.lng], map.getZoom());
        }
    }, [center, map]);

    useEffect(() => {
        if (route && route.length > 1) {
            const bounds = L.latLngBounds(route.map(point => [point.lat, point.lng]));
            map.fitBounds(bounds, { padding: [20, 20] });
        }
    }, [route, map]);

    return null;
};

const MapView = ({ currentLocation, route, isRiding }) => {
    const defaultCenter = { lat: 35.6762, lng: 139.6503 };
    const center = currentLocation || defaultCenter;
    
    const customMarker = useMemo(() => createCustomMarker(isRiding), [isRiding]);
    
    const routePositions = useMemo(() => {
        return route && route.length > 1 
            ? route.map(point => [point.lat, point.lng])
            : [];
    }, [route]);

    return (
        <div className="map-view">
            <div className="osm-map">
                <MapContainer
                    center={[center.lat, center.lng]}
                    zoom={16}
                    style={{ height: '100%', width: '100%' }}
                    zoomControl={true}
                    attributionControl={true}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    
                    <MapController center={currentLocation} route={route} />
                    
                    {currentLocation && (
                        <Marker 
                            position={[currentLocation.lat, currentLocation.lng]}
                            icon={customMarker}
                        />
                    )}
                    
                    {routePositions.length > 1 && (
                        <Polyline
                            positions={routePositions}
                            pathOptions={{
                                color: '#ff6b6b',
                                weight: 4,
                                opacity: 1.0
                            }}
                        />
                    )}
                </MapContainer>
            </div>
            {isRiding && (
                <div className="map-overlay">
                    <div className="riding-indicator">
                        <div className="pulse-dot"></div>
                        乗車中
                    </div>
                </div>
            )}
        </div>
    );
};

export default MapView;